module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAVFBMVEUAAADbAEm/AEDGADnRAEbMAEbNAETLAEXLAETLAETLAETKAEPLAEXLAETLAEXKAEXMAEXLAETLAEPMAEPKAETLAETLAETLAETLAETLAETLAET///+bfqnXAAAAGnRSTlMABwgJCygpnJ2etLe6u7y9vb7Bw8fI7e7v8HxWZJQAAAABYktHRBsCYNSkAAAAo0lEQVQ4y93TyxKDIAyF4WhQasVeFLyc93/QLrCKmtB93f7f4EwgVPvJMolfeRtDRR6AEwU7AIEWKIIdAMxkIYvYYam4AwB6I3ZXkiy4Sw4WxKEL4tQv4tJPQugHIfZEKH0TwxvaaFeh9lQ45XqLNvan0olfEQxG6d33F73Jd1ms/dEqYpuP9j72+f3l+6Dm1+LM+dVbKOSX11MVxka5f7aTrz+qDCO+3yJSgAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/close_red.png
// module id = 129
// module chunks = 0